var render = function (_h,_vm) {var _c=_vm._c;return _c('v-icon',{staticClass:"atom-icon-book-open",class:{
    'icon-book-open-active': _vm.props.active
  }},[_vm._v("mdi-book-open-variant")])}
var staticRenderFns = []

export { render, staticRenderFns }